import { Link, useLocation } from "react-router-dom";
import { NAV_ITEMS } from "@/components/feature/navItems";
import { siteStats } from "@/mocks/home";

export default function SiteSidebar() {
  const location = useLocation();

  const isActive = (item: (typeof NAV_ITEMS)[number]) =>
    item.matches.some((match) =>
      match === "/" ? location.pathname === "/" : location.pathname.startsWith(match),
    );

  return (
    <aside className="fixed inset-y-0 left-0 z-40 hidden w-64 flex-col border-r border-background-200/80 bg-background-50 lg:flex">
      <Link to="/" className="flex h-20 shrink-0 flex-col justify-center border-b border-background-200/80 px-6">
        <span className="flex items-center gap-2">
          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 font-heading text-sm font-bold text-background-50">
            日
          </span>
          <span className="font-heading text-xl font-black tracking-wide text-foreground-950">日本女优</span>
        </span>
        <span className="mt-1 font-label text-[10px] tracking-[0.22em] text-foreground-400">
          JAPAN ACTRESS ARCHIVE
        </span>
      </Link>

      <nav className="flex-1 overflow-y-auto px-3 py-5">
        <p className="px-3 pb-2 font-label text-[11px] tracking-[0.18em] text-foreground-400">资料索引</p>
        <ul className="space-y-1">
          {NAV_ITEMS.map((item) => {
            const active = isActive(item);
            return (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className={`relative flex items-center gap-3 rounded-md px-3 py-2.5 font-label text-sm transition-colors ${
                    active
                      ? "bg-primary-50 font-medium text-primary-800"
                      : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                  }`}
                >
                  {active ? (
                    <span className="absolute left-0 top-1/2 h-5 w-[3px] -translate-y-1/2 rounded-full bg-accent-500"></span>
                  ) : null}
                  <span className="flex h-5 w-5 items-center justify-center">
                    <i className={`${item.icon} text-base`} aria-hidden="true"></i>
                  </span>
                  {item.label}
                  {active ? (
                    <i className="ri-arrow-right-s-line ml-auto text-primary-400" aria-hidden="true"></i>
                  ) : null}
                </Link>
              </li>
            );
          })}
        </ul>

        <div className="mt-6 rounded-lg border border-background-200 bg-background-100 p-4">
          <p className="flex items-center gap-1.5 font-label text-xs font-medium text-foreground-800">
            <i className="ri-bar-chart-box-line text-primary-600" aria-hidden="true"></i>
            资料库概览
          </p>
          <dl className="mt-3 space-y-2">
            {siteStats.map((stat) => (
              <div key={stat.label} className="flex items-baseline justify-between">
                <dt className="font-label text-[11px] text-foreground-500">{stat.label}</dt>
                <dd className="font-heading text-sm font-bold text-foreground-900">
                  {stat.value}
                  <span className="ml-0.5 font-label text-[10px] font-normal text-foreground-500">
                    {stat.unit}
                  </span>
                </dd>
              </div>
            ))}
          </dl>
          <div className="mt-3 h-px w-full bg-background-300"></div>
          <p className="mt-2.5 font-label text-[10px] leading-relaxed text-foreground-500">
            资料每日整理，示例内容用于演示检索与浏览体验。
          </p>
        </div>

        <div className="mt-4 rounded-lg border border-accent-200 bg-accent-50 p-4">
          <p className="flex items-center gap-1.5 font-label text-xs font-medium text-accent-900">
            <i className="ri-heart-3-line" aria-hidden="true"></i>
            收藏说明
          </p>
          <p className="mt-1.5 font-label text-[10px] leading-relaxed text-accent-900/80">
            收藏为前端演示功能，状态仅保存在当前浏览器，不会上传至服务器。
          </p>
        </div>
      </nav>

      <div className="border-t border-background-200/80 p-4">
        <Link
          to="/about"
          className="flex items-center gap-2 rounded-md px-2 py-2 font-label text-xs text-foreground-600 transition-colors hover:text-primary-700"
        >
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-mail-line" aria-hidden="true"></i>
          </span>
          关于本站与联系方式
        </Link>
      </div>
    </aside>
  );
}